import jwtDecode from 'jwt-decode'

interface MyToken {
  exp: number;
}
const isValidJWT = (token: string | null) => {
  if (!token) {
    return false
  }
  const decoded = jwtDecode<MyToken>(token)
  const currentTime = Date.now() / 1000
  if (decoded.exp < currentTime) {
    console.warn('access token expired')
    return false
  } else {
    return true
  }
}

export default isValidJWT
